import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'

import styles from 'src/styles/common.module.scss'
import { useMediaQuery } from 'src/lib/use-media-query'

export const TextHeaderEs = () => {
    const isDesktop = useMediaQuery('(min-width: 540px)')

    return (
        <HighlightedText
            text="Gira la rueda y consigue giros gratis"
            highlights={[
                { word: 'giros', className: styles.textHighlights },
                { word: 'gratis', className: styles.textHighlights },
            ]}
            breakAfterWords={isDesktop ? ['consigue'] : ['rueda', 'consigue']}
            className={styles.text_header}
        />
    )
}
